import React, { useMemo, useState } from "react";
import { useConfig, useTicket } from "../../../store/Store";
import { processAdjustmentsData } from "../../general/AppHelpers";
import TipAdjustment from "./TipAdjustment";
import AdjustmentItem from "../AdjustmentItem";
import { AppointmentIcon } from "../../general/Icons";
import { useTranslation } from "react-i18next";

const Appointments = () => {
  const { data: ticketData } = useTicket();
  const { accessToken } = useConfig();
  const { t } = useTranslation();

  const [submittingTip, setSubmittingTip] = useState(false);

  const { slotVariationAdjustments } = useMemo(
    () => processAdjustmentsData(ticketData?.resource?.adjustments),
    [ticketData]
  );

  const getAppointmentStartTime = (adjustments) => {
    return (
      new Date(adjustments[0]?.adjustment?.appointment_date).toLocaleDateString(
        undefined,
        {
          year: "numeric",
          month: "long",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        }
      ) || null
    );
  };

  const appointmentAdjustmentElements = useMemo(() => {
    return Object.keys(slotVariationAdjustments)?.map((appointmentId) => {
      const appointmentAssociatedAdjustments =
        slotVariationAdjustments[Number(appointmentId)] || [];
      return (
        <>
          <div className="pl-8 mt-2">
            <div className="flex gap-1 items-center">
              <p className="text-sm text-black">
                {getAppointmentStartTime(appointmentAssociatedAdjustments)}
              </p>
            </div>
          </div>
          {appointmentAssociatedAdjustments?.map(
            ({ adjustment, associatedTaxes }, index) => (
              // to be updated with specific component
              <AdjustmentItem
                key={`slot-variation-${index}`}
                adjustment={adjustment}
                taxes={associatedTaxes}
              />
            )
          )}
          <TipAdjustment
            ticketData={ticketData}
            accessToken={accessToken}
            key={`tip-${appointmentId}`}
            appointmentId={Number(appointmentId)}
            adjustments={ticketData?.resource?.adjustments}
            setSubmittingTip={setSubmittingTip}
            submittingTip={submittingTip}
          />
        </>
      );
    });
  }, [
    slotVariationAdjustments,
    ticketData,
    submittingTip,
    setSubmittingTip,
    accessToken,
  ]);

  if (!appointmentAdjustmentElements?.length) {
    return null;
  }

  return (
    <div className="py-5" data-testid="appointments-container">
      <div
        className="flex items-center gap-2 mb-2"
        data-testid="appointments-header"
      >
        <AppointmentIcon />
        <h3
          className="text-lg font-medium text-black"
          data-testid="appointments-title"
        >
          {t("ticketItemsSections.appointments")}
        </h3>
      </div>
      <div className="flex flex-col gap-2" data-testid="appointments-list">
        {appointmentAdjustmentElements}
      </div>
    </div>
  );
};

export default Appointments;
